import { render, staticRenderFns } from "./CanalCobroCreate.vue?vue&type=template&id=102f0250&scoped=true"
import script from "./CanalCobroCreate.vue?vue&type=script&lang=js"
export * from "./CanalCobroCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102f0250",
  null
  
)

export default component.exports